import { automationsRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { UpdateAutomationJson } from '../types';

export const useUpdateAutomation = () =>
  useMutation<number, unknown, UpdateAutomationJson>((updateAutomation) =>
    automationsRepo.updateAutomation(updateAutomation),
  );
